export const API_BASE = process.env
  .NEXT_PUBLIC_RETROACTIVE_COMPENSATION_API_BASE as string
export const SIGNATURE_TYPE = 'Retroactive Compensation'
